import { Bell, ClipboardList, Contact, Store, Timer, Users } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const salonsConfig: LandingConfig = {
  slug: 'salons',
  namespace: 'landing-salons',
  analyticsId: 'for-salons',
  canonicalPath: '/for-salons',
  ogImagePath: '/images/og-salons.jpg',
  heroImage: '/images/hero-salons',
  // Order matches landing-salons:features.items[]
  featureIcons: [Store, Bell, Users, ClipboardList, Contact, Timer],
  comparison: VERTICAL_COMPARISON,
};
